import { render, staticRenderFns } from "./StepThree.vue?vue&type=template&id=859f9ac2"
import script from "./StepThree.vue?vue&type=script&lang=ts"
export * from "./StepThree.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports